import { render, staticRenderFns } from "./FacilitiesVietnamPage.vue?vue&type=template&id=5d473226&scoped=true&"
import script from "./FacilitiesVietnamPage.vue?vue&type=script&lang=js&"
export * from "./FacilitiesVietnamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d473226",
  null
  
)

export default component.exports